import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EMPTY, merge, Observable } from 'rxjs';
import { catchError, filter, first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class IpService {
  ip: string;
  userId: any;

  /** Strict IPv4 only — reject IPv6 / junk before sending to backend. */
  private readonly ipv4Regex =
    /^(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)\.){3}(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)$/;

  constructor(private http: HttpClient) { }

  /**
   * Race free IPv4 providers — first valid IPv4 wins.
   */
  public getIPAddresss(): Observable<{ ip: string }> {
    return merge(
      this.fetchFromIpify(),
      this.fetchFromIdentMe(),
      this.fetchFromIpPubblico(),
      // this.fetchIpFromAPI()
    ).pipe(first());
  }


  private fetchIpFromAPI(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>('https://adminapibetaangular.opinionest.com/api/network/get-ip').pipe(
      map(res => res && res.ip),
      filter((ip): ip is string => !!ip && this.ipv4Regex.test(ip.trim())),
      map(ip => ({ ip: ip.trim() })),
      catchError(() => EMPTY)
    );
  }

  private fetchFromIpify(): Observable<{ ip: string }> {
    return this.http.get<{ ip: string }>('https://api.ipify.org/?format=json').pipe(
      map(res => res && res.ip),
      filter((ip): ip is string => !!ip && this.ipv4Regex.test(ip.trim())),
      map(ip => ({ ip: ip.trim() })),
      catchError(() => EMPTY)
    );
  }

  /** https://ident.me/.json → { "address": "x.x.x.x" } */
  private fetchFromIdentMe(): Observable<{ ip: string }> {
    return this.http.get<{ address: string }>('https://4.ident.me/.json').pipe(
      map(res => res && res.address),
      filter((ip): ip is string => !!ip && this.ipv4Regex.test(ip.trim())),
      map(ip => ({ ip: ip.trim() })),
      catchError(() => EMPTY)
    );
  }

  /** https://ipv4.ippubblico.org/ → plain-text IPv4 */
  private fetchFromIpPubblico(): Observable<{ ip: string }> {
    return this.http.get('https://ipv4.ippubblico.org/', { responseType: 'text' }).pipe(
      map((ip: string) => (ip || '').trim()),
      filter(ip => this.ipv4Regex.test(ip)),
      map(ip => ({ ip })),
      catchError(() => EMPTY)
    );
  }
}
